import React, { Component } from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import PageVille from './PageVille'
import { getValueFromUrlValue } from 'src/utils'

const villeQuery = gql`
  query ProducersAround($idVille: ID!, $category: String!) {
    producersAround(idVille: $idVille, category: $category) {
      producers {
        id
        companyName
        presentation
        photoProducerUrl
        categories
        addressCity
        addressPostalCode
        addressCoordinates
        distance
      }

      nearestCities {
        id
        name
      }

      city {
        id
        name
        postalCode
        coordinates {
          x
          y
        }
      }

      error
      regionName
      departmentName
      regionCode
      departmentCode
    }
  }
`

class PageVilleContainer extends Component {
  render() {
    const category = getValueFromUrlValue(this.props.match.params.category)

    return (
      <Query
        query={villeQuery}
        variables={{
          idVille: this.props.match.params.idVille,
          category
        }}
      >
        {({ loading, data }) => (
          <PageVille
            loading={loading}
            producersAround={!loading && data ? data.producersAround : null}
            category={category}
          />
        )}
      </Query>
    )
  }
}

export default PageVilleContainer
